import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { MetricService } from '../../../insight/performance-data/metric.service';
import { epicDependencies } from '../../../store';
import { BaseMultiText } from '../../../translation';
import { currentBuilderState } from '../builder.state';

import { filterMetrics } from './filter-metrics.function';

export function loadMetrics(): Observable<void> {
    const metricService =
        epicDependencies.injector.get<MetricService>(MetricService);

    return metricService.list().pipe(
        catchErrorLogRet([]),
        tap((ret) => {
            _loadMetrics(ret);
        }),
        mapTo(null),
    );
}

function _loadMetrics(ret: BaseMultiText[]): void {
    const state = currentBuilderState();

    ret.forEach((cm) => {
        cm.fullName = (cm.fullName ?? '').trim();
    });
    ret.sort((a, b) => a.fullName.localeCompare(b.fullName));

    state.metrics = ret;

    filterMetrics();
}
